import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { MapPinPlus, X } from "lucide-react";
import { toast } from "sonner";

export default function Locations() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name:"", address:"", latitude:45.5152, longitude:-122.6784, geofence_radius_ft:200 });

  const load = () => api.get("/locations").then((r)=>setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/locations", {
        ...f,
        latitude: Number(f.latitude),
        longitude: Number(f.longitude),
        geofence_radius_ft: Number(f.geofence_radius_ft),
      });
      toast.success("Site added");
      setOpen(false); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-8">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <div className="accp-label">Sites</div>
          <h1 className="text-4xl font-semibold text-primary" style={{fontFamily:'Outfit'}}>Locations</h1>
          <p className="text-muted-foreground mt-1">Geofenced care sites — clock-in enforced within the radius.</p>
        </div>
        <button className="accp-btn-primary" onClick={()=>setOpen(true)} data-testid="add-location-btn">
          <MapPinPlus size={16}/> Add site
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {rows.map((l) => (
          <div key={l.id} className="accp-card p-5">
            <div className="accp-label">{l.geofence_radius_ft} ft geofence</div>
            <h3 className="text-xl font-semibold text-primary mt-1" style={{fontFamily:'Outfit'}}>{l.name}</h3>
            <div className="text-sm text-muted-foreground mt-1">{l.address}</div>
            <div className="mt-3 text-xs font-mono text-muted-foreground">
              {l.latitude}, {l.longitude}
            </div>
          </div>
        ))}
      </div>

      {open && (
        <div className="accp-modal-shell" onClick={()=>setOpen(false)}>
          <form onClick={(e)=>e.stopPropagation()} onSubmit={submit} className="accp-modal-card space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-semibold text-primary" style={{fontFamily:'Outfit'}}>Add site</h3>
              <button type="button" onClick={()=>setOpen(false)}><X size={18}/></button>
            </div>
            <label><span className="accp-label">Name</span>
              <input className="accp-input mt-1" required value={f.name} onChange={(e)=>setF({...f, name:e.target.value})}/>
            </label>
            <label><span className="accp-label">Address</span>
              <input className="accp-input mt-1" value={f.address} onChange={(e)=>setF({...f, address:e.target.value})}/>
            </label>
            <div className="grid grid-cols-2 gap-3">
              <label><span className="accp-label">Latitude</span>
                <input type="number" step="any" className="accp-input mt-1" required value={f.latitude} onChange={(e)=>setF({...f, latitude:e.target.value})}/>
              </label>
              <label><span className="accp-label">Longitude</span>
                <input type="number" step="any" className="accp-input mt-1" required value={f.longitude} onChange={(e)=>setF({...f, longitude:e.target.value})}/>
              </label>
            </div>
            <label><span className="accp-label">Geofence radius (ft)</span>
              <input type="number" className="accp-input mt-1" value={f.geofence_radius_ft} onChange={(e)=>setF({...f, geofence_radius_ft:e.target.value})}/>
            </label>
            <button type="submit" className="accp-btn-primary w-full">Save site</button>
          </form>
        </div>
      )}
    </div>
  );
}
